/* ═══════════════════════════════════════════════════════════════════
   SERENE — Featured Collection (Owl Carousel + Card Height Sync)
   ──────────────────────────────────────────────────────────────────
   Önceden featured-collection.liquid içine inline <script> olarak
   her section instance için ayrı ayrı emit ediliyordu (~92 satır).
   29 APR 2026'da bu paylaşılan dosyaya taşındı; artık her section
   sadece küçük bir init çağrısı yapıyor:

     window.sereneInitFeaturedCollection(sectionId, { columnsMobile, columnsDesktop });

   Idempotent: aynı sayfada birden fazla section render edilse bile
   ortak fonksiyonlar tek kez tanımlanır.
   ═══════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__sereneFeaturedCollectionLoaded) return;
  window.__sereneFeaturedCollectionLoaded = true;

  // ── Kart yüksekliği eşitleme + buton hizalama ─────────────
  function sereneAlignCards(sectionId) {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var $cards = $('#Slider-' + sectionId + ' .card-wrapper');
    if (!$cards.length) return;

    // 1. Sıfırla — doğru ölçüm için
    $cards.css('height', '');
    $cards.find('.card:not(.ratio)').css('height', '');
    $cards.find('.card__content').css('height', '');
    $cards.find('.card__information').css('height', '');

    // 2. En uzun kartı bul
    var maxH = 0;
    $cards.each(function() { maxH = Math.max(maxH, $(this).outerHeight()); });
    if (!maxH) return;

    // 3. Tüm kartları eşitle
    $cards.css({ height: maxH + 'px', display: 'flex', 'flex-direction': 'column' });

    // 4. İç zinciri zorla: card → card__content → card__information
    $cards.each(function() {
      var $cw = $(this);
      var cwH = $cw.innerHeight();

      var $card = $cw.find('.card:not(.ratio)').first();
      $card.css({ height: cwH + 'px', display: 'flex', 'flex-direction': 'column' });

      // card__content: image'dan sonra kalan alan
      var $inner = $card.find('.card__inner').first();
      var innerH = $inner.outerHeight(true) || 0;
      var contentH = cwH - innerH;

      var $content = $card.find('> .card__content').first();
      $content.css({
        height: contentH + 'px',
        display: 'flex',
        'flex-direction': 'column',
        'flex-shrink': '0'
      });

      // card__information fiyat + buton en alta
      var $info = $content.find('.card__information').first();
      $info.css({ display: 'flex', 'flex-direction': 'column', height: '100%' });
      $info.find('.card-information').first().css('margin-top', 'auto');
    });
  }

  // ── Owl carousel init (per selector) ──────────────────────
  function initOwl(selector, sectionId, opts) {
    var $ = window.jQuery;
    var $owl = $(selector);
    if ($owl.hasClass('owl-loaded')) return;
    if (!$owl.length) return;

    $owl.owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      autoplay: false,
      responsive: {
        0:    { items: 1 },
        320:  { items: opts.columnsMobile },
        480:  { items: Math.max(1, opts.columnsDesktop - 3) },
        541:  { items: Math.max(1, opts.columnsDesktop - 2) },
        768:  { items: Math.max(1, opts.columnsDesktop - 2) },
        990:  { items: Math.max(1, opts.columnsDesktop - 1) },
        1367: { items: opts.columnsDesktop }
      }
    });

    // Kartları eşitle: init + slide
    $owl.on('initialized.owl.carousel changed.owl.carousel', function() {
      setTimeout(function() { sereneAlignCards(sectionId); }, 100);
    });
  }

  // ── Public init (her section instance bunu çağırır) ───────
  var initializedSections = new Set();
  window.sereneInitFeaturedCollection = function(sectionId, opts) {
    if (initializedSections.has(sectionId)) return;
    initializedSections.add(sectionId);
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;

    $(document).ready(function() {
      initOwl('.layout-grid #Slider-' + sectionId + '.product-grid.owl-carousel', sectionId, opts);
      initOwl('.layout-grid_with_banner #Slider-' + sectionId + '.product-grid.owl-carousel', sectionId, opts);
    });

    // Resize & load handler'ları (her section için ayrı kayıt — sectionId closure)
    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { sereneAlignCards(sectionId); }, 250);
    });
    $(window).on('load', function() {
      setTimeout(function() { sereneAlignCards(sectionId); }, 200);
    });
  };

  // Geriye dönük uyumluluk: eski global isim hâlâ çalışsın
  window.sereneAlignCards = sereneAlignCards;
})();
